module.exports = __webpack_public_path__ + "static/img/empty.ec9a04cc.png";